import {useTranslations} from 'next-intl';
import Container from '@/container';
import LogosCarousel, {type CustomerLogo, type LogosCarouselProps} from '@/ui/logos-carousel';

const LOGO_BASE = '/static/images/workable-ai/customer-logos';

export type CustomerLogosCarouselProps = Pick<
  LogosCarouselProps,
  'fadeColor' | 'fadeStart' | 'fadeEnd' | 'muted'
>;

const CustomerLogosCarousel = ({
  fadeColor,
  fadeStart,
  fadeEnd,
  muted
}: CustomerLogosCarouselProps) => {
  const t = useTranslations('workableAi.customerLogos');
  const logos = t.raw('logos') as CustomerLogo[];

  return (
    <Container>
      <LogosCarousel
        logos={logos}
        logoBase={LOGO_BASE}
        ariaLabel={t('ariaLabel')}
        fadeColor={fadeColor}
        fadeStart={fadeStart}
        fadeEnd={fadeEnd}
        muted={muted}
      />
    </Container>
  );
};

export default CustomerLogosCarousel;
